import React, { useState } from 'react';
import axios from 'axios';

function RegisterUser() {
  const [userid, setUserid] = useState('');
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('user');

  const handleRegister = async () => {
    const token = sessionStorage.getItem('token');
    try {
      await axios.post('/api/auth/register', { userid, name, password, role }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      alert('등록 완료');
    } catch {
      alert('등록 실패 (관리자만 가능)');
    }
  };

  return (
    <div className="container mt-5">
      <h2>👤 회원 등록 (관리자 전용)</h2>
      <input className="form-control mb-2" placeholder="아이디" value={userid} onChange={(e) => setUserid(e.target.value)} />
      <input className="form-control mb-2" placeholder="이름" value={name} onChange={(e) => setName(e.target.value)} />
      <input className="form-control mb-2" type="password" placeholder="비밀번호" value={password} onChange={(e) => setPassword(e.target.value)} />
      <select className="form-control mb-2" value={role} onChange={(e) => setRole(e.target.value)}>
        <option value="user">일반 사용자</option>
        <option value="admin">관리자</option>
      </select>
      <button className="btn btn-success" onClick={handleRegister}>등록</button>
    </div>
  );
}

export default RegisterUser;